import gql from 'graphql-tag'
import { useMutation } from '@apollo/client'
import { CampaignBannerInput } from 'front-end/src/graphql/private/PrivateSchemaTypes'

export interface ICreateCampaignBannerVariables {
  id: number
  input: CampaignBannerInput
}

export interface IResponse {
  admin: {
    campaign: {
      id: number
      createBanner: {
        id: number
      }
    }
  }
}

export const mutation = gql`
  mutation createCampaignBanner(
    $id: PositiveInt!
    $input: CampaignBannerInput!
  ) {
    admin {
      campaign(id: $id) {
        id
        createBanner(input: $input) {
          id
        }
      }
    }
  }
`

export const createBanner = () =>
  useMutation<IResponse, ICreateCampaignBannerVariables>(mutation)
